import { routes } from '@/core/routes';
import { LinkButton } from '@infinex/ui/components';

export default function NotFoundPage() {
  return (
    <section className="flex grow py-6">
      <div className="mx-auto flex max-w-6xl grow flex-col items-center justify-center gap-y-8 text-center">
        <h1 className="text-3xl font-semibold md:text-4xl">Page not found</h1>

        <LinkButton href={routes.root}>Go to Home</LinkButton>
      </div>
    </section>
  );
}
